import { IMienGiamSoTien } from "../../../model/respone/mien-giam/IMienGiamSoTien";
import { IMienGiamSoTienPagingRequest } from "../../../model/request/mien-giam/IMienGiamSoTienRequest";
import { IMienGiamSoTienActionTypes } from "../../action-types/mien-giam/IMienGiamSoTienActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMienGiamSoTienReducer } from "../../reducer-model/mien-giam/IMienGiamSoTienReducer";

const iniState: IMienGiamSoTienReducer = {
  status: eReducerStatusBase.is_not_initialization,
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_lops: [],
    trang_thai: -1,
    tu_khoa: "",
    page_index: 0,
    page_size: 20,
  },
  items: [],
  tongSoDong: 0,
  selectedIds: [],
  isShowEditModal: false,
  isShowImportModal: false,
};

export const mienGiamSoTienReducer = (
  state: IMienGiamSoTienReducer = iniState,
  action: IMienGiamSoTienActionTypes,
): IMienGiamSoTienReducer => {
  switch (action.type) {
    case "MIEN_GIAM_SO_TIEN_CHANGE_REQUEST": {
      return {
        ...state,
        request: action.payload as IMienGiamSoTienPagingRequest,
        // Đổi bộ lọc thì phải nạp lại; giữ nguyên dấu tick của trang cũ là thao tác nhầm dòng.
        status: eReducerStatusBase.is_need_reload,
        selectedIds: [],
      };
    }
    case "MIEN_GIAM_SO_TIEN_LOAD_START": {
      return { ...state, status: eReducerStatusBase.is_loading };
    }
    case "MIEN_GIAM_SO_TIEN_LOAD_SUCCESS": {
      const items = (action.payload as IMienGiamSoTien[]) ?? [];
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        items,
        // Thủ tục trả tổng số dòng kèm từng dòng; trang rỗng thì tổng cũng là 0.
        tongSoDong: items.length > 0 ? items[0].tong_so_dong : 0,
      };
    }
    case "MIEN_GIAM_SO_TIEN_LOAD_ERROR": {
      return { ...state, status: eReducerStatusBase.is_completed, items: [] };
    }
    case "MIEN_GIAM_SO_TIEN_CHANGE_SELECTED_IDS": {
      return { ...state, selectedIds: (action.payload as number[]) ?? [] };
    }
    case "MIEN_GIAM_SO_TIEN_SHOW_EDIT_MODAL": {
      return {
        ...state,
        isShowEditModal: true,
        editItem: action.payload as IMienGiamSoTien | undefined,
      };
    }
    case "MIEN_GIAM_SO_TIEN_HIDE_EDIT_MODAL": {
      return { ...state, isShowEditModal: false, editItem: undefined };
    }
    case "MIEN_GIAM_SO_TIEN_SHOW_IMPORT_MODAL": {
      return { ...state, isShowImportModal: true };
    }
    case "MIEN_GIAM_SO_TIEN_HIDE_IMPORT_MODAL": {
      return { ...state, isShowImportModal: false };
    }
    case "MIEN_GIAM_SO_TIEN_SAVE_SUCCESS":
    case "MIEN_GIAM_SO_TIEN_DUYET_SUCCESS":
    case "MIEN_GIAM_SO_TIEN_DELETE_SUCCESS": {
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
        isShowImportModal: false,
        editItem: undefined,
        selectedIds: [],
      };
    }
    default:
      return state;
  }
};
